import { Injectable, LOCALE_ID, inject } from '@angular/core';

const ICORTEX_DEPLOYMENT_HUB_BASE = 'https://icortex.ai/help';


/**
 * @description Resolves the public Deployment Hub (help center) URL from site locale (path prefix or LOCALE_ID).
 */
@Injectable( {
  providedIn: 'root'
} )
export class IcortexDeploymentHubUrlService {

  private readonly localeId = inject( LOCALE_ID );


  /**
   * @description Full help URL; Spanish context uses /help/es.
   * @return Deployment Hub URL for the active language.
   */
  getDeploymentHubHref(): string {

    if ( this.resolveIsSpanishSiteContext() ) {

      return `${ ICORTEX_DEPLOYMENT_HUB_BASE }/es`;
    }

    return `${ ICORTEX_DEPLOYMENT_HUB_BASE }/`;
  }


  /**
   * @description Detects Spanish from URL prefix (/es/...) or Angular LOCALE_ID (localized builds).
   * @return True when the public site context is Spanish.
   */
  private resolveIsSpanishSiteContext(): boolean {

    if ( typeof window !== 'undefined' && window.location ) {

      const firstSegment = ( window.location.pathname || '' )
        .split( '/' )
        .filter( ( segment ) => segment.length > 0 )[ 0 ]
        ?.toLowerCase();

      if ( firstSegment === 'es' ) {

        return true;
      }
    }

    return this.localeId === 'es';
  }

}
